module.exports = __webpack_public_path__ + "img/symbol_14.9cb28285.png";